import React from 'react';

const problemsData = [
  "Shoulder pain (SCT 45326006)",
  "Asthma (SCT 195967001)",
  "Bilateral lower leg edema (SCT 831620002)",
  "Gross hematuria (SCT 59743005)",
  "Mixed hyperlipidemia (SCT 251654003)",
  "Morbid obesity (SCT 228150006)",
  "Asthma (SCT 195967001)",
  "Obstructive sleep apnea (SCT 78275009)",
  "Pain of right shoulder joint (SCT 15971183000119100)",
  "Deficiency of glucose-6-phosphate dehydrogenase (SCT 124134002)",
  "Vitamin D deficiency (SCT 34713006)"
];

const ActiveProblems = () => {
  return (
    <div  style={{ height: 270, overflowY: 'auto', padding: "8px" ,marginLeft:12}}>
      <div style={{ 
        fontWeight: "bold", 
        marginBottom: "12px",
        fontSize: "14px",
        color: "#333",
        marginLeft:12
      }}>
        Problem List
      </div>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        gap: '8px'
      }}>
        {problemsData.map((problem, idx) => (
          <li 
            key={idx} 
            style={{
              padding: '4px 6px',
              backgroundColor: '#fff',
              fontSize: "13px",
              color: "#333",
              fontWeight: "normal",
              marginLeft:12
            }}
          >
            {problem}
          </li>
        ))}
      </div>
    </div>
  );
};

export default ActiveProblems;
